import {
  CLEAR_REPORT_JWT,
  SET_REPORT_JWT,
  SET_REPORT_JWT_ERR,
} from "../actions/reportJwt";

export default function reportJwtReducer(
  jwt = {},
  { type, newReportJwt = null, error = null, secretExpiresAt = null }
) {
  switch (type) {
    case SET_REPORT_JWT: {
      return { jwt: newReportJwt, error: null, secretExpiresAt };
    }
    case SET_REPORT_JWT_ERR: {
      return { jwt: null, error, secretExpiresAt: null };
    }
    case CLEAR_REPORT_JWT:
      return {};
    default:
      return jwt;
  }
}
